import Util from '@/lib/util'
import _ from "lodash";

export default [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width: 80,
        align:"center"
      },
    {
        title:Util.L('Đối tác'),
        key:'product',
        width: 150,
        render:(h:any,params:any)=> { return h("span", !_.isEmpty(_.get(params,'row.product.clientCode')) ? _.get(params,'row.product.clientCode') + ' - ' + _.get(params,'row.product.clientName') : null); }
    },{
        title:Util.L('Ngành hàng'),
        key:'product',
        width: 120,
        render:(h:any,params:any)=> { return h("span", _.get(params,'row.product.productCategory.code') + ' - ' + _.get(params,'row.product.productCategory.name')); }
    },
    {
        title:Util.L('Mã sản phẩm'),
        key:'shortName',
        width: 120,
        render:(h:any,params:any)=> { return h("span", params.row.product.sku); }
    },
    {
        title:Util.L('Tên sản phẩm'),
        key:'shortName',
        width: 170,
        render:(h:any,params:any)=> { return h("span", params.row.product.name); }
    },
    {
        title:Util.L('Ngày áp dụng'),
        key:'effectiveDate',
        width: 210,
        align: 'center',
        render:(h:any,params:any)=> { return h("span", Util.toViewDatePickerString(params.row.effectiveDate)); }
    },
    {
        title:Util.L('Thời gian BH(ngày)'),
        key:'duration',
        width: 120,
        align: 'right',
        render:(h:any,params:any)=> { return h("span", Util.toViewNumberString(params.row.duration)); }
    },
    {
        title: ' ',
        width:100,
        fixed:'right',
        slot: 'action',
        align: 'center'
    }]